import { render } from "./AddPlayerForm.vue?vue&type=template&id=1a202f9c&scoped=true"
import script from "./AddPlayerForm.vue?vue&type=script&lang=js"
export * from "./AddPlayerForm.vue?vue&type=script&lang=js"

import "./AddPlayerForm.vue?vue&type=style&index=0&id=1a202f9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a202f9c"]])

export default __exports__